import { useEffect } from 'react';
import { Switch, useParams, Route } from 'react-router-dom';
import { PageRoute, BackToFlow } from 'shared/components';
import { usePersonalLoan, useRedirect } from 'shared/hooks';
import {
  AdditionalProfileContainer,
  CompleteContainer,
  EmployerVerificationContainer,
  FrozenLockContainer,
  IDUploadContainer,
  MultiProduct,
  OfferSelectContainer,
  SsnContainer,
} from 'components';
import NotYetEligibleContainer from 'shared/components/ReviewApp/containers/NotYetEligibleContainer';
import BankRouter from './BankRouter';
import DeclineRouter from './DeclineRouter';
import FundingRouter from './FundingRouter';
import IncomeRouter from './IncomeRouter';
import ReviewAppRouter from './ReviewAppRouter';
import SigningRouter from './SigningRouter';

const NoMatchRedirectToDashboard = () => {
  const { redirectToDashboard } = useRedirect();
  redirectToDashboard();
  return null;
};

const PersonalLoanRouter = () => {
  const { uuid: personalLoanUuid } = useParams();
  const { activatePersonalLoan } = usePersonalLoan();

  const pageRouteProps = {
    unsecured: true,
    isTwoColLayout: false,
    isCompleteApplication: false,
  };

  useEffect(() => {
    activatePersonalLoan(personalLoanUuid);
  }, [personalLoanUuid, activatePersonalLoan]);

  return (
    <Switch>
      <Route exact path="/applications/:uuid/multi-product">
        <MultiProduct />
      </Route>
      <PageRoute exact path="/applications/:uuid/offer-select" hasLeaveSurvey {...pageRouteProps}>
        <OfferSelectContainer />
      </PageRoute>
      <PageRoute exact path="/applications/:uuid/additional-info" hasLeaveSurvey {...pageRouteProps}>
        <AdditionalProfileContainer />
      </PageRoute>
      <PageRoute exact path="/applications/:uuid/id-upload" hasLeaveSurvey>
        <IDUploadContainer />
      </PageRoute>

      <PageRoute exact path="/applications/:uuid/employer-verification" hasLeaveSurvey>
        <EmployerVerificationContainer />
      </PageRoute>

      <PageRoute exact path="/applications/:uuid/complete" isCompleteApplication>
        <CompleteContainer />
      </PageRoute>

      <PageRoute exact path="/applications/:uuid/not-yet-eligible">
        <NotYetEligibleContainer />
      </PageRoute>

      <Route path="/applications/:uuid/bank" component={BankRouter} />
      <Route path="/applications/:uuid/decline" component={DeclineRouter} />
      <Route path="/applications/:uuid/funding" component={FundingRouter} />
      <Route path="/applications/:uuid/income" component={IncomeRouter} />
      <Route path="/applications/:uuid/signing" component={SigningRouter} />
      <Route path="/applications/:uuid/review-app" component={ReviewAppRouter} />

      <PageRoute exact path="/applications/:uuid/credit/social">
        <SsnContainer />
      </PageRoute>
      <PageRoute exact path="/applications/:uuid/credit/error">
        <FrozenLockContainer />
      </PageRoute>

      <Route exact path="/applications/:uuid" component={BackToFlow} />

      <Route path="*" component={NoMatchRedirectToDashboard} />
    </Switch>
  );
};

export default PersonalLoanRouter;
